import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignCenterHorizontalSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41659 12.3957C6.41659 12.6373 6.61247 12.8332 6.85409 12.8332C7.0957 12.8332 7.29159 12.6373 7.29159 12.3957V11.0832H7.93325C8.42331 11.0832 8.66831 11.0832 8.8555 10.9878C9.02012 10.9039 9.15399 10.77 9.23788 10.6054C9.33325 10.4182 9.33325 10.1732 9.33325 9.68317V9.5665C9.33325 9.07645 9.33325 8.83145 9.23788 8.64425C9.15399 8.47964 9.02012 8.34576 8.8555 8.26188C8.66831 8.1665 8.42331 8.1665 7.93325 8.1665H7.29159V6.4165H9.97492C10.465 6.4165 10.71 6.4165 10.8972 6.32113C11.0618 6.23725 11.1957 6.10337 11.2795 5.93875C11.3749 5.75157 11.3749 5.50655 11.3749 5.0165V4.89984C11.3749 4.40979 11.3749 4.16477 11.2795 3.97759C11.1957 3.81295 11.0618 3.6791 10.8972 3.59521C10.71 3.49984 10.465 3.49984 9.97492 3.49984H7.29159V1.604C7.29159 1.36238 7.0957 1.1665 6.85409 1.1665C6.61247 1.1665 6.41659 1.36238 6.41659 1.604V3.49984H3.73325C3.24321 3.49984 2.99818 3.49984 2.81101 3.59521C2.64637 3.6791 2.51251 3.81295 2.42862 3.97759C2.33325 4.16477 2.33325 4.40979 2.33325 4.89984V5.0165C2.33325 5.50655 2.33325 5.75157 2.42862 5.93875C2.51251 6.10337 2.64637 6.23725 2.81101 6.32113C2.99818 6.4165 3.24321 6.4165 3.73325 6.4165H6.41659V8.1665H5.77492C5.28487 8.1665 5.03985 8.1665 4.85267 8.26188C4.68803 8.34576 4.55418 8.47964 4.47029 8.64425C4.37492 8.83145 4.37492 9.07645 4.37492 9.5665V9.68317C4.37492 10.1732 4.37492 10.4182 4.47029 10.6054C4.55418 10.77 4.68803 10.9039 4.85267 10.9878C5.03985 11.0832 5.28487 11.0832 5.77492 11.0832H6.41659V12.3957Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignCenterHorizontalSVG;
